import { useTenant } from '@elka/hooks';
import { db } from '@/lib/firebase/config';

export interface GmailEnabledState {
  /** Whether Gmail-backed features (inbound inbox, bid-request emails) are on. */
  enabled: boolean;
  /** Still resolving the tenant registry doc — callers should defer routing. */
  isLoading: boolean;
}

/** Resolves the tenant's `features.gmail` flag. */
export function useGmailEnabled(): GmailEnabledState {
  const { features, isLoading } = useTenant(db);
  return { enabled: !!features.gmail, isLoading };
}
